var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.113 13.1V6.688c0-.225-.15-.375-.375-.375s-.375.15-.375.375v6.562a.34.34 0 0 0 .113.262l4.312 4.35a.405.405 0 0 0 .263.113.34.34 0 0 0 .262-.113.363.363 0 0 0 0-.524l-4.2-4.238Z",
    fill: "#D18357",
    stroke: "#D18357",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C5.812 1.25.75 6.313.75 12.5c0 6.188 5.063 11.25 11.25 11.25 6.188 0 11.25-5.063 11.25-11.25 0-6.188-5.063-11.25-11.25-11.25ZM12 23C6.225 23 1.5 18.275 1.5 12.5S6.225 2 12 2s10.5 4.725 10.5 10.5S17.775 23 12 23Z",
    fill: "#D18357",
    stroke: "#D18357",
    strokeWidth: 0.5
  })));
};
export default SvgClock;